<template>
  <div>
    <div class="form-check form-check-inline">
      <input
        :id="'negate-false-' + id"
        :name="'negate-' + id"
        :checked="negate !== 'true'"
        class="form-check-input"
        type="radio"
        value="false"
        @change="$emit('update:negate', 'false')"
      >
      <label class="form-check-label" :for="'negate-false-' + id">This event was completed</label>
    </div>
    <div class="form-check form-check-inline">
      <input
        :id="'negate-true-' + id"
        :name="'negate-' + id"
        :checked="negate === 'true'"
        class="form-check-input"
        type="radio"
        value="true"
        @change="$emit('update:negate', 'true')"
      >
      <label class="form-check-label" :for="'negate-true-' + id">This event was NOT completed</label>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      negate: {
        type: String,
        default: 'false'
      },
      id: String
    }
  };
</script>
